require('./myProfileTppRemoveConsentView.scss');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @actions
const myProfileKeysTppsActions = require('actions/myProfileKeysTpps/myProfileKeysTpps');
const myProfileKeysTppsRemoveActions = require('actions/myProfileKeysTpps/myProfileKeysTppsRemove');

// @commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const WebappRender = require('components/conditionalRender/webappRender');
const { ContactInfoBoxCCValidated : ContactInfoBox } = require('components/myProfile/contactInfoBox/contactInfoBox');
const { OKIconIllustrative } = require('commonsComponents/OKIconIllustrative');
const { OKButton } = require('components/commons/OKButton/OKButton');
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');
const { LoadingSection } = require('commonsComponents/loadingSection');

const MyProfileTppRemoveConsentResumeView = require('./myProfileTppRemoveConsentResumeView/myProfileTppRemoveConsentResumeView');
const MyProfileTppRemoveConsentSuccess = require('./myProfileTppRemoveConsentSuccessView/myProfileTppRemoveConsentSuccessView');

//components
const ErrorView = require('components/myProfile/tppKeysComponents/tppKeyError/tppKeyError');

//@helpers
const { FormattedText, formatText, getFinalTitle } = require('core/i18n').i18n;
const { filterAccountsInfo } = require('utilities/tpps/tppKeysHelper');

//@constants
const infoIcon = require('assets/images/icon-info-blue.svg');

class MyProfileTppRemoveConsentView extends React.Component {
    componentDidMount = () => {
        const {
            getTppKeyConsents,
            match: { params: {tppId} },
            immProfileKeysTpps
        } = this.props;

        if(immProfileKeysTpps.get('tpps').size === 0) {
            getTppKeyConsents(tppId);
        }

    }

    handleRemove = () => {
        const {validateRemoveConsent, match: { params: {consentId} } } = this.props;
        validateRemoveConsent(consentId);
    }

    handleRetry = () => {
        const { retryRemoveConsentTpp } = this.props;
        retryRemoveConsentTpp();
    }

    buildBoxBody = () => {
       return (
            <div>
                <OKIconIllustrative icon="info" product="banking" />
                <FormattedText
                    className="contact-info-box__list-item-value"
                    value="keysTppView-removeBoxBody"
                />
            </div>
        );
    }

    buildButtonSection = () => {
        const {immProfileKeysTpps} = this.props;

        return (
            <div className="keys-remove-consent-view__cta-buttons">
                <div className="keys-remove-tpp-view__separator"/>
                <div className="keys-remove-consent-view__buttons-wrapper">
                    <OKButton modifier="link-ghost" to="/myProfile/keys/tpps">
                        <FormattedText value="keysTppView-removeTPPKeyCancel" />
                    </OKButton>
                    <div className="keys-remove-consent-view__button-right">
                        <SignaturePatternButton loading={immProfileKeysTpps.get('isFetchingRemove')} id="btnConsentTppRemove" onClick={this.handleRemove} >
                            <FormattedText value="keysTppView-removeTPPKeyConfirm" />
                        </SignaturePatternButton>
                    </div>
                </div>
            </div>
        )
    }

    buildSignatureAndInfoSection = () => {
        const { match: { params: {tppId, consentId} }, immProfileKeysTpps, immAccounts} = this.props;

        const tppInfo = immProfileKeysTpps.get('tpps').get(tppId);
        const productList = tppInfo && tppInfo.toJS().consent && tppInfo.toJS().consent.products && tppInfo.toJS().consent.products[0] && tppInfo.toJS().consent.products[0].items || [];
        const filteredAccountsInfo = productList.length > 0 ? filterAccountsInfo({ immAccounts: immAccounts.get("byId"), productListId: productList.map(product => product.id) }) : [];

        return immProfileKeysTpps.get("consentsHaveBeenFetched") ?
            <MyProfileTppRemoveConsentResumeView
                consentId={consentId}
                productsAffected={filteredAccountsInfo}
            />
        : null;
    }

    buildSuccessSection = () => {
        const {resetTppKey} = this.props;

        return (
            <div className="row grid-view--content-position-negative">
                <div className="col-xs-12 col-md-offset-2 col-md-8">
                    <MyProfileTppRemoveConsentSuccess resetTppKey={resetTppKey}/>
                </div>
            </div>
        )
    }

    buildRemoveSection = () => {
        const boxBody = this.buildBoxBody();
        const signatureAndInfoSection = this.buildSignatureAndInfoSection();
        const buttonSection = this.buildButtonSection();

        return (
            <div className="row grid-view--content-position-negative">
                <div className="col-xs-12 col-md-8">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="keys-remove-consent-view">
                                { signatureAndInfoSection }
                                {buttonSection}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 col-md-4">
                    <div className="row">
                        <div className="col-xs-12 grid-view--variable-cell-separation">
                            <WebappRender>
                                <ContactInfoBox
                                    boxTitle={formatText('keysTppView-removeBoxTitle')}
                                    boxBody={boxBody}
                                    icon={infoIcon}
                                />
                            </WebappRender>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    buildError = () => {
        const title = <FormattedText value="keysTppView-removeTppKeyError"/>;
        return (
            <div className="row grid-view--content-position-negative">
                <div className="col-xs-12 col-md-offset-2 col-md-8">
                    <ErrorView
                        title={title}
                        onRetry={this.handleRetry}
                    />
                </div>
            </div>
        )
    }

    buildLoadingComponent = () => {
        return (<div><LoadingSection /></div>);
    }

    render() {
        const {immProfileKeysTpps} = this.props;
        const mappingBreadcrumb = [
            ...(!__CONTACT_CENTER__ ? [
                {
                    text: formatText('profileKeysLanding-title'),
                    url: '/myprofile/keys'
                }
            ] : []),
            {
                text: formatText('profileKeysLanding-changeTPP'),
                url: '/myProfile/keys/tpps'
            },
            {
                text: formatText('removeConsentTppView-removeConsentTppTitle'),
                url: ''
            }
        ];

        let content = immProfileKeysTpps.get('isFetchingRemove') ? this.buildLoadingComponent()
        : immProfileKeysTpps.get('removeSuccessful') ? this.buildSuccessSection()
        : immProfileKeysTpps.get('removeFailure') ? this.buildError()
        : this.buildRemoveSection();

        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="large" section="accounts" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle('removeConsentTppView-removeConsentTppTitle')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        {content}
                    </div>
                </div>
            </div>
        );

    }
}

MyProfileTppRemoveConsentView.propTypes = {
    consentId: PropTypes.string,
    immProfileKeysTpps: PropTypes.object,
    immAccounts: PropTypes.object,
    match: PropTypes.object.isRequired,
    getTppKeyConsents: PropTypes.func.isRequired,
    retryRemoveConsentTpp: PropTypes.func.isRequired,
    resetTppKey: PropTypes.func.isRequired,
    validateRemoveConsent: PropTypes.func.isRequired,
}

module.exports.constructor = MyProfileTppRemoveConsentView;
module.exports.MyProfileTppRemoveConsentView = connect (
    state => ({
        immAccounts: state.accounts,
        immProfileKeysTpps: state.myProfileKeysTpps,
    }),
    {
        validateRemoveConsent: myProfileKeysTppsRemoveActions.validateRemoveConsent,
        resetTppKey: myProfileKeysTppsActions.resetTppKey,
        retryRemoveConsentTpp: myProfileKeysTppsActions.retryRemoveConsentTpp,
        getTppKeyConsents: myProfileKeysTppsActions.getTppKeyConsents,
    })(MyProfileTppRemoveConsentView);
